import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PulseChipComponent } from '../pulse-chip';
import type { FilterChip } from './pulse-filter-chips.types';

@Component({
    selector: 'pulse-filter-chips',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslateModule, PulseChipComponent],
    templateUrl: './pulse-filter-chips.component.html',
    styleUrl: './pulse-filter-chips.component.scss',
    host: {
        class: 'pulse-filter-chips',
    },
})
export class PulseFilterChipsComponent<K = string> {
    readonly chips = input<readonly FilterChip<K>[]>([]);
    readonly label = input('');
    readonly removable = input(false);
    readonly maxShown = input(Number.POSITIVE_INFINITY);
    readonly removed = output<K>();

    protected readonly shownChips = computed(() => this.chips().slice(0, this.maxShown()));

    protected readonly hiddenCount = computed(() => this.chips().length - this.shownChips().length);
}
